var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46020_26176)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#125266"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_46020_26176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7071 36.1537L49.4604 25.0825C50.3773 24.7171 51.2853 25.6302 50.9153 26.5463L42.4596 47.4953C42.2126 48.107 41.4956 48.3743 40.9096 48.0739L21.6111 38.1962C20.7531 37.7566 20.8111 36.5102 21.7061 36.1537H21.7071Z",
    stroke: "url(#paint0_linear_46020_26176)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5728 25.2461L30.2773 42.6328V47.8751C30.2773 48.8002 31.3313 49.3278 32.0703 48.7742L36.2132 45.6715",
    stroke: "url(#paint1_linear_46020_26176)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_46020_26176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7071 36.1537L49.4604 25.0825C50.3773 24.7171 51.2853 25.6302 50.9153 26.5463L42.4596 47.4953C42.2126 48.107 41.4956 48.3743 40.9096 48.0739L21.6111 38.1962C20.7531 37.7566 20.8111 36.5102 21.7061 36.1537H21.7071Z",
    stroke: "url(#paint2_linear_46020_26176)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5728 25.2461L30.2773 42.6328V47.8751C30.2773 48.8002 31.3313 49.3278 32.0703 48.7742L36.2132 45.6715",
    stroke: "url(#paint3_linear_46020_26176)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_46020_26176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7071 36.1537L49.4604 25.0825C50.3773 24.7171 51.2853 25.6302 50.9153 26.5463L42.4596 47.4953C42.2126 48.107 41.4956 48.3743 40.9096 48.0739L21.6111 38.1962C20.7531 37.7566 20.8111 36.5102 21.7061 36.1537H21.7071Z",
    stroke: "url(#paint4_linear_46020_26176)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5728 25.2461L30.2773 42.6328V47.8751C30.2773 48.8002 31.3313 49.3278 32.0703 48.7742L36.2132 45.6715",
    stroke: "url(#paint5_linear_46020_26176)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_46020_26176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7071 36.1537L49.4604 25.0825C50.3773 24.7171 51.2853 25.6302 50.9153 26.5463L42.4596 47.4953C42.2126 48.107 41.4956 48.3743 40.9096 48.0739L21.6111 38.1962C20.7531 37.7566 20.8111 36.5102 21.7061 36.1537H21.7071Z",
    stroke: "url(#paint6_linear_46020_26176)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5728 25.2461L30.2773 42.6328V47.8751C30.2773 48.8002 31.3313 49.3278 32.0703 48.7742L36.2132 45.6715",
    stroke: "url(#paint7_linear_46020_26176)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.7071 36.1537L49.4604 25.0825C50.3773 24.7171 51.2853 25.6302 50.9153 26.5463L42.4596 47.4953C42.2126 48.107 41.4956 48.3743 40.9096 48.0739L21.6111 38.1962C20.7531 37.7566 20.8111 36.5102 21.7061 36.1537H21.7071Z",
    stroke: "#9CDCF0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5728 25.2461L30.2773 42.6328V47.8751C30.2773 48.8002 31.3313 49.3278 32.0703 48.7742L36.2132 45.6715",
    stroke: "#9CDCF0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_46020_26176",
    x: 8.2,
    y: 12.1961,
    width: 55.6024,
    height: 49.6039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6,
    result: "effect1_foregroundBlur_46020_26176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_46020_26176",
    x: 8.2,
    y: 12.1961,
    width: 55.6024,
    height: 49.6039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6,
    result: "effect1_foregroundBlur_46020_26176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_46020_26176",
    x: 8.2,
    y: 12.1961,
    width: 55.6024,
    height: 49.6039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6,
    result: "effect1_foregroundBlur_46020_26176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_46020_26176",
    x: 8.2,
    y: 12.1961,
    width: 55.6024,
    height: 49.6039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6,
    result: "effect1_foregroundBlur_46020_26176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46020_26176",
    x1: 36,
    y1: 25,
    x2: 36,
    y2: 48.1976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A599F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109A6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_46020_26176",
    x1: 40.4251,
    y1: 25.2461,
    x2: 40.4251,
    y2: 48.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A599F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109A6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_46020_26176",
    x1: 36,
    y1: 25,
    x2: 36,
    y2: 48.1976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A599F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109A6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_46020_26176",
    x1: 40.4251,
    y1: 25.2461,
    x2: 40.4251,
    y2: 48.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A599F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109A6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_46020_26176",
    x1: 36,
    y1: 25,
    x2: 36,
    y2: 48.1976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A599F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109A6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_46020_26176",
    x1: 40.4251,
    y1: 25.2461,
    x2: 40.4251,
    y2: 48.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A599F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109A6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_46020_26176",
    x1: 36,
    y1: 25,
    x2: 36,
    y2: 48.1976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A599F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109A6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_46020_26176",
    x1: 40.4251,
    y1: 25.2461,
    x2: 40.4251,
    y2: 48.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A599F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109A6C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46020_26176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconEnabled);
export default __webpack_public_path__ + "static/media/sendIconEnabled.5cd1590198f38ef61622fc119b1c7408.svg";
export { ForwardRef as ReactComponent };